// src/pages/About/CarreirasPage.jsx

import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  WorkOutline as JobIcon,
  LocationOn as LocationIcon,
  Timer as TimerIcon,
  Close as CloseIcon,
  CheckCircle as CheckIcon,
  EmojiEvents as BenefitsIcon,
  Diversity3 as CultureIcon,
  School as EducationIcon,
  Lightbulb as ValuesIcon,
} from '@mui/icons-material';
import Footer from '../../components/Footer/Footer';

// Dados das vagas disponíveis
const availableJobs = [
  {
    id: 1,
    title: "Desenvolvedor Full Stack",
    department: "Tecnologia",
    location: "Maputo",
    type: "Tempo Integral",
    experience: "3+ anos",
    description: "Procuramos um desenvolvedor Full Stack experiente para se juntar à nossa equipe...",
    requirements: [
      "Experiência com React e Node.js",
      "Conhecimento em bancos de dados SQL e NoSQL",
      "Experiência com metodologias ágeis",
      "Boa comunicação e trabalho em equipe"
    ],
    responsibilities: [
      "Desenvolver novas funcionalidades",
      "Manter e optimizar sistemas existentes",
      "Colaborar com a equipe de produto",
      "Participar de code reviews"
    ]
  },
  {
    id: 2,
    title: "Customer Success Manager",
    department: "Suporte",
    location: "Maputo",
    type: "Tempo Integral",
    experience: "2+ anos",
    description: "Buscamos um profissional apaixonado por atendimento ao cliente...",
    requirements: [
      "Experiência em suporte ao cliente",
      "Excelentes habilidades de comunicação",
      "Conhecimento do sector educacional",
      "Proatividade e organização"
    ],
    responsibilities: [
      "Gerir relacionamento com clientes",
      "Garantir satisfação dos usuários",
      "Realizar treinamentos",
      "Resolver problemas complexos"
    ]
  },
  // Adicione mais vagas conforme necessário
];

// Benefícios oferecidos
const benefits = [
 
  {
    title: "Desenvolvimento Profissional",
    description: "Orçamento anual para cursos e certificações"
  },
  {
    title: "Horário Flexível",
    description: "Equilibre trabalho e vida pessoal"
  },
  {
    title: "Ambiente Remoto",
    description: "Possibilidade de trabalho híbrido ou remoto"
  },
  // Adicione mais benefícios conforme necessário
];

const CarreirasPage = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [applicationData, setApplicationData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: null
  });

  const handleApply = (job) => {
    setSelectedJob(job);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setSelectedJob(null);
    setApplicationData({
      name: '',
      email: '',
      phone: '',
      resume: null
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implementar lógica de envio
    console.log('Application submitted:', applicationData);
    handleClose();
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          py: 8,
          position: 'relative',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" component="h1" gutterBottom align="center">
            Carreiras no ZenKroll
          </Typography>
          <Typography variant="h5" align="center" paragraph>
            Junte-se a nós na missão de transformar a educação em Moçambique
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: -4, position: 'relative', zIndex: 1 }}>
        {/* Cards de Cultura */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%', bgcolor: 'background.paper' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CultureIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Nossa Cultura</Typography>
              </Box>
              <Typography>
                Valorizamos a diversidade, inovação e colaboração em um ambiente 
                dinâmico e acolhedor.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%', bgcolor: 'background.paper' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <ValuesIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Nossos Valores</Typography>
              </Box>
              <Typography>
                Excelência, transparência e compromisso com a educação são os pilares 
                do nosso trabalho.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%', bgcolor: 'background.paper' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <EducationIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h6">Desenvolvimento</Typography>
              </Box>
              <Typography>
                Investimos no crescimento profissional e pessoal de cada membro 
                da nossa equipe.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Benefícios */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="h4" gutterBottom>
            Benefícios
          </Typography>
          <Grid container spacing={3}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <BenefitsIcon color="primary" sx={{ mb: 1 }} />
                    <Typography variant="h6" gutterBottom>
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {benefit.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Vagas Disponíveis */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="h4" gutterBottom>
            Vagas Disponíveis
          </Typography>
          <Grid container spacing={3}>
            {availableJobs.map((job) => (
              <Grid item xs={12} key={job.id}>
                <Card
                  sx={{
                    '&:hover': {
                      boxShadow: 6,
                      transform: 'translateY(-2px)',
                      transition: 'all 0.2s'
                    }
                  }}
                >
                  <CardContent>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>
                          {job.title}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <JobIcon sx={{ mr: 1, fontSize: 20 }} color="action" />
                          <Typography variant="body2" color="text.secondary">
                            {job.department}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <LocationIcon sx={{ mr: 1, fontSize: 20 }} color="action" />
                          <Typography variant="body2" color="text.secondary">
                            {job.location}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <TimerIcon sx={{ mr: 1, fontSize: 20 }} color="action" />
                          <Typography variant="body2" color="text.secondary">
                            {job.type}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleApply(job)}
                        >
                          Candidatar-se
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Dialog de Candidatura */}
        <Dialog 
          open={openDialog} 
          onClose={handleClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6">
                Candidatura para {selectedJob?.title}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    label="Nome Completo"
                    value={applicationData.name}
                    onChange={(e) => setApplicationData({
                      ...applicationData,
                      name: e.target.value
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Email"
                    type="email"
                    value={applicationData.email}
                    onChange={(e) => setApplicationData({
                      ...applicationData,
                      email: e.target.value
                    })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Telefone"
                    value={applicationData.phone}
                    onChange={(e) => setApplicationData({
                      ...applicationData,
                      phone: e.target.value
                    })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                  >
                    Anexar Currículo
                    <input
                      type="file"
                      hidden
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => setApplicationData({
                        ...applicationData,
                        resume: e.target.files[0]
                      })}
                    />
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button 
              variant="contained" 
              onClick={handleSubmit}
              disabled={!applicationData.name || !applicationData.email || !applicationData.phone}
            >
              Enviar Candidatura
            </Button>
          </DialogActions>
        </Dialog>
      </Container>

      <Footer />
    </Box>
  );
};

export default CarreirasPage;